import React from "react";

import dayjs from "dayjs";
import "dayjs/locale/es";
import { Trash2 } from "lucide-react";

import { Badge } from "~/components/ui/badge";
import PaymentBadge from "~/pages/purchase-orders/components/sales-notes/PaymentBadge";
import StatusBadge from "~/pages/purchase-orders/components/sales-notes/StatusBadge";
import { MobileSalesCardProps } from "~/pages/purchase-orders/types/sales-notes";
import { formatCurrency } from "~/utils/helpers";
import { grossFromNet } from "~/utils/iva";
import { getDisplayId } from "~/utils/salesRequestDisplayUtils";

// Configure dayjs
dayjs.locale("es");

export const MobileSalesCard: React.FC<MobileSalesCardProps> = ({
  order,
  clientNames,
  clientInfo,
  handleOrderClick,
}) => {
  return (
    <div
      key={order.id}
      className="cursor-pointer rounded-md border bg-white p-3 shadow-sm hover:bg-gray-50"
      onClick={() => handleOrderClick(order)}
    >
      <div className="mb-2 flex items-start justify-between">
        <div>
          <div className="flex items-center gap-1">
            <p className="text-sm font-medium">
              {clientNames[order.clientId] || "Cliente sin nombre"}
            </p>
            {clientInfo?.[order.clientId]?.isDeleted && (
              <Badge variant="destructive" className="px-1 py-0 text-xs">
                <Trash2 className="mr-1 h-3 w-3" />
                Eliminado
              </Badge>
            )}
          </div>
          <p className="text-xs text-gray-500">ID: {getDisplayId(order)}</p>
          <p className="text-xs text-gray-500">
            {dayjs(order.createdAt).format("DD/MM/YYYY")}
          </p>
          <p className="text-xs text-gray-500">
            Última actualización:{" "}
            {dayjs(order.updatedAt).format("DD/MM/YYYY HH:mm")}
          </p>
        </div>
        <StatusBadge status={order.status} size="xs" />
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <PaymentBadge
            paid={order.paid}
            status={order.status}
            previousStatus={order.previousStatus}
          />
        </div>
        <span className="text-sm font-semibold">
          {formatCurrency(grossFromNet(order.totalAmount, order.isExento))}
          <span className="ml-1 text-xs text-gray-500">(con IVA)</span>
        </span>
      </div>
    </div>
  );
};

export default MobileSalesCard;
